import { DateTime } from "@/Common/Helpers/DateTime";
import { BilledServiceComposite } from "./BilledServiceComposite";

class SavePrivateBillRequestModel {
    public EncounterId: string;
    public DateOfVisit: DateTime;
    public SiteId: string;
    public ProviderId: string;
    public CreatedById: string;
    public PatientId: string;
    public PaymentMethod: number;
    public DiscountType: number;
    public Discount: number;
    public TotalGST: number;
    public TotalQST: number;
    public TotalHST: number;
    public TotalGenericTax: number;
    public Total: number;
    public GSTPercent: number;
    public QSTPercent: number;
    public HSTPercent: number;
    public GenericTaxPercent: number;
    public Notes: string;
    public BilledServices: BilledServiceComposite[];
    public IsFromClose: boolean;
    public IsFromEdition: boolean;
    public PrivateBillId: string;
    public RecipientName: string;
    public RecipientAddress: string;
    public RecipientPhoneNumber: string;
    public RecipientFaxNumber: string;
    public BilledTo: number;

    public constructor(init?: Partial<SavePrivateBillRequestModel>) {
        this.BilledServices = [];
        Object.assign(this, init);
    }
}

export { SavePrivateBillRequestModel };
